import { useQuery } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
const USE_RETRIEVE_USER_EXTERNAL_MATCH_PERMISSIONS = "useRetrieveUserExternalMatchPermissions";
const USE_RETRIEVE_USER_INTRA_SQUAD_MATCH_PERMISSIONS = "useRetrieveUserIntraSquadMatchPermissions";
const USE_RETRIEVE_USER_INTRA_SQUAD_TOURNAMENT_PERMISSIONS = "useRetrieveUserIntraSquadTournamentPermissions";
const USE_RETRIEVE_USER_LEAGUE_PERMISSIONS = "useRetrieveUserLeaguePermissions";
const USE_RETRIEVE_USER_LEAGUE_MATCH_PERMISSIONS = "useRetrieveUserLeagueMatchPermissions";
const USE_RETRIEVE_USER_LEAGUE_MATCH_STATS_PERMISSIONS = "useRetrieveUserLeagueMatchStatsPermissions";
export const useRetrieveUserExternalMatchPermissions = ({ externalMatchId, }) => {
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_EXTERNAL_MATCH_PERMISSIONS, externalMatchId],
        queryFn: async () => {
            const response = await api.get(`/permissions/external-matches/${externalMatchId}/`);
            return response.data;
        },
        enabled: !!externalMatchId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useRetrieveUserIntraSquadMatchPermissions = ({ intraSquadMatchId, }) => {
    return useQuery({
        queryKey: [
            USE_RETRIEVE_USER_INTRA_SQUAD_MATCH_PERMISSIONS,
            intraSquadMatchId,
        ],
        queryFn: async () => {
            const response = await api.get(`/permissions/intra-squad-matches/${intraSquadMatchId}/`);
            return response.data;
        },
        enabled: !!intraSquadMatchId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useRetrieveUserIntraSquadTournamentPermissions = ({ tournamentId, }) => {
    return useQuery({
        queryKey: [
            USE_RETRIEVE_USER_INTRA_SQUAD_TOURNAMENT_PERMISSIONS,
            tournamentId,
        ],
        queryFn: async () => {
            const response = await api.get(`/permissions/intra-squad-tournaments/${tournamentId}/`);
            return response.data;
        },
        enabled: !!tournamentId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useRetrieveUserLeaguePermissions = ({ leagueId, }) => {
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_LEAGUE_PERMISSIONS, leagueId],
        queryFn: async () => {
            const response = await api.get(`/permissions/league/${leagueId}/`);
            return response.data;
        },
        enabled: !!leagueId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useRetrieveUserLeagueMatchPermissions = ({ leagueMatchId, }) => {
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_LEAGUE_MATCH_PERMISSIONS, leagueMatchId],
        queryFn: async () => {
            const response = await api.get(`/permissions/league-matches/${leagueMatchId}/`);
            return response.data;
        },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useRetrieveUserLeagueMatchStatsPermissions = ({ leagueMatchId, enabled = true, }) => {
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_LEAGUE_MATCH_STATS_PERMISSIONS, leagueMatchId],
        queryFn: async () => {
            const response = await api.get(`/permissions/league-match-stats/${leagueMatchId}/`);
            return response.data;
        },
        enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
